import React, { useEffect, useState } from "react";
import { TbClockHour4 } from "react-icons/tb";
import { IoMdCloseCircleOutline } from "react-icons/io";
import { GoIssueClosed } from "react-icons/go";
import { CgUserAdd } from "react-icons/cg";
import axios from "axios";
import { getAccessToken } from "../../storage/storage";
import { TableSkelton2, TableSkelton3 } from "../../components/Skeletons";
import { Link } from "react-router-dom";

const SendInvitation = () => {
  const dummyData = [
    {
      ref: "REQ-2-25-001",
      email: "Sarah Johnson",
      details: "Modern & Dog friendly",
      date: "27/01/2025",
      icon: <GoIssueClosed />,
      status: "Accepted",
      time: "27/01/2025",
      action: "-",
    },
    {
      ref: "REQ-2-25-001",
      email: "Sarah Johnson",
      details: "Modern & Dog friendly",
      date: "27/01/2025",
      icon: <TbClockHour4 />,
      status: "Pending",
      time: "27/01/2025",
      action: "",
    },
    {
      ref: "REQ-2-25-001",
      email: "Sarah Johnson",
      details: "Modern & Dog friendly",
      date: "27/01/2025",
      icon: <IoMdCloseCircleOutline />,
      status: "Declined",
      time: "27/01/2025",
      action: "-",
    },
  ];

  const token = getAccessToken();
  const BASE_URL = process.env.REACT_APP_BASE_URL;
  const [data, setData] = useState([]);
  const [loading, setLoading] = useState(false);

  useEffect(() => {
    setLoading(true);
    axios
      .get(`${BASE_URL}/api/invitations/user/`, {
        headers: {
          Authorization: `Bearer ${token}`,
        },
      })
      .then((response) => {
        setData(response.data);
        setLoading(false);
      })
      .catch((error) => {
        setLoading(false);
        console.error("Error fetching options:", error);
      });
  }, []);

  return (
    <div className="md:p-10 p-5 h-[100vh]">
      <div className="flex md:flex-row flex-col gap-5 md:gap-0 items-center justify-between w-full mb-8">
        <div>
          <h1 className="md:text-3xl text-lg font-bold text-[#586989] mb-2">
            My Cleaners Dashboard{" "}
          </h1>

          <p className="text-gray-600">
            Track and manage invitations send to cleaners
          </p>
        </div>
        <Link
          to="/invite-cleaner"
          className="flex items-center gap-3 bg-[#586989] px-4 py-3 rounded text-white font-medium"
        >
          <CgUserAdd className="text-[20px] font-semibold" />
          Send Invitation{" "}
        </Link>{" "}
      </div>
      <div className="flex justify-start ">
        <div className="border border-[#DFDFDF] bg-white rounded-lg shadow-md overflow-x-auto w-full h-[70vh] max-w-auto">
          <table className="w-full min-w-[600px]">
            {/* Table Head */}
            <thead className="bg-[#FFF5CE] text-[#586989] font-medium text-[14px] md:text-[16px]">
              <tr>
                <th className="py-6 px-4 min-w-[150px] text-center">
                  First Name
                </th>
                <th className="py-3 px-4 min-w-[150px] text-center">
                  Surname{" "}
                </th>
                <th className="py-3 px-4 min-w-[150px] text-center">Email </th>
                <th className="py-3 px-4 min-w-[150px] text-center">Message</th>
                <th className="py-3 px-4 min-w-[150px] text-center">Status</th>
                <th className="py-3 px-4 min-w-[150px] text-center">
                  Mobile Number
                </th>
                <th className="py-3 px-4 min-w-[150px] text-center">
                  Property
                </th>
              </tr>
            </thead>

            {/* Table Body */}
            <tbody>
              {loading ? (
                <>
                  <TableSkelton3 />
                </>
              ) : data.length > 0 ? (
                data.map((row, index) => (
                  <tr
                    key={index}
                    className="bg-white text-[#1B1E27] border-t border-t-[#DFDFDF] text-left text-[12px] md:text-[16px]"
                  >
                    <td className="px-4 py-6 text-center">{row.first_name}</td>
                    <td className="px-4 py-6 text-center">{row.surname}</td>
                    <td className="px-4 py-6 text-center">{row.email}</td>
                    <td className="px-4 py-6 text-center">{row.message}</td>
                    <td className="px-4 py-6 text-center">{row.status}</td>

                    <td className="px-4 py-6 flex items-center justify-center gap-2">
                      <p className=" text-[#586989] text-center">
                        {row.mobile_number}
                      </p>
                    </td>
                    <td className="px-4 py-6 text-center">
                      {row.property_name}
                    </td>
                  </tr>
                ))
              ) : (
                <tr>
                  <td
                    colSpan="7"
                    className="text-center text-lg font-bold text-[#586989] h-[400px]"
                  >
                    No invitations found
                  </td>
                </tr>
              )}
            </tbody>
          </table>
        </div>
      </div>
    </div>
  );
};

export default SendInvitation;
